import React from "react"
import { Container } from "@carrotfertility/carotene"
import { ContentfulConditionalGate } from "lib/contentful/components/ContentfulConditionGate"
import { ExpertBioProps } from "./ExpertBioParser"
import { Link as ReactRouterLink, useHistory } from "react-router-dom"
import { ExpertBio } from "components/read/shared/ExpertBioMapper"
import { useIntl } from "react-intl"
import { Box, LeftIcon, Link } from "@carrotfertility/carotene-core"
import { ContentfulRawMarkdownRenderer } from "services/contentful"
import { defaultMarkdownElements } from "services/markdown"
import { Title } from "services/page-title/Title"
import { PageLayout } from "features/global-ui/page-layout"
import { PageBreadcrumbHeader } from "features/global-ui/page-header"

type PreviousPage = {
  path: string
  title: string
}

const ExpertHeader = ({
  previousPageRoute,
  previousPageTitle
}: {
  previousPageRoute: string
  previousPageTitle: string
}): JSX.Element => {
  return (
    <Link color="inherit" display="flex" width="fit-content" component={ReactRouterLink} to={previousPageRoute}>
      <LeftIcon />
      {previousPageTitle}
    </Link>
  )
}

const ExpertOverview = ({ name }: { name: string }): JSX.Element => (
  <>
    <defaultMarkdownElements.h1.component {...defaultMarkdownElements.h1.props}>
      {name}
    </defaultMarkdownElements.h1.component>
  </>
)

const ExpertDetails = ({ expert }: { expert: ExpertBio }): JSX.Element => {
  const { name, description } = expert
  return (
    <Box width={{ xs: "unset", md: "600px" }}>
      <ExpertOverview name={name} />
      <ContentfulRawMarkdownRenderer>{description}</ContentfulRawMarkdownRenderer>
    </Box>
  )
}

const ExpertBioProfilePage = ({ expertBio }: ExpertBioProps): JSX.Element => {
  const intl = useIntl()
  const history = useHistory()
  const { path = "/read", title = intl.formatMessage({ defaultMessage: "Read & learn" }) } =
    (history.location.state as PreviousPage) || {}
  const expertSlugId = `${expertBio.slug}-${expertBio.id}`
  return (
    <>
      <Title title={expertBio.name} productTitle="About the expert" />
      <PageLayout
        header={
          <PageBreadcrumbHeader breadcrumbs={<ExpertHeader previousPageRoute={path} previousPageTitle={title} />} />
        }
      >
        <ContentfulConditionalGate conditions={expertBio?.conditions}>
          <Box
            display="flex"
            gap={(theme) => theme.spacing(theme.tokens.spacing.xxxl)}
            flexDirection="column"
            data-expert-id={expertSlugId}
          >
            <Container>
              <Box
                component="img"
                src={expertBio?.headshot?.file?.url}
                alt=""
                height="80px"
                width="80px"
                sx={{
                  marginBottom: (theme) => theme.spacing(theme.tokens.spacing.lg),
                  borderRadius: (theme) => theme.tokens.borderRadius.md
                }}
              />
              <ExpertDetails expert={expertBio} />
            </Container>
          </Box>
        </ContentfulConditionalGate>
      </PageLayout>
    </>
  )
}

export default ExpertBioProfilePage
